const DRAWER_WIDTH = 300
export const DYNAMIC_DRAWER_WIDTH =
  window.innerWidth > DRAWER_WIDTH ? DRAWER_WIDTH : window.innerWidth
export const TOP_BAR_HEIGHT = 60
